export const environment = {
    production: true,
    testing: false,
    development: false,
    training: false,
    hasServiceWorker: true,
    theme: 'paws',
    appUrl: 'https://paws2.usask.ca/login', //Example: https://myapp.com
    casUrl: 'https://cas.usask.ca/cas', //Example: https://mycas.com/cas
    casValidateUrl: 'https://cas.usask.ca/cas/serviceValidate', //Example: https://mycas.com/cas/serviceValidate
    casClientID: "paws2",
    pubDate: "Wed 04 Nov 2026 03:06:49 PM CST",
    revision: "1.1.24.1793826409",
    webPath: "/",
    domain: "paws2.usask.ca",
    apiURL: "https://paws2.usask.ca/pawsapi/api",
    chatAPI:  "https://paws2.usask.ca/uchat/api", // "https://paws2.usask.ca/pawsapi/api/uchat", //https://pawsdev.usask.ca/uchat/api",
    uchatAPI: "https://paws2.usask.ca/uchat-py",
    myProfileLink: "https://myprofile.usask.ca/home.jsf",
    sorryLink: "https://sorry.usask.ca/paws_down.html",
    helpLink: "https://teamdynamix.usask.ca/TDClient/33/Portal/KB/ArticleDet?ID=274", //https://wiki.usask.ca/x/AIGybw",
    oldPAWSLink: "https://paws5.usask.ca",
    applCategories: "PASS,EVAL,OTPT,EMRG,UOFS,NEWS,FEAT",
    countdownEventsUrl: "https://portalapps.usask.ca/countdown_events/countdown_eventgenerator.php?v=4",
    announcementURL: "https://portalapps.usask.ca/announcements/",
    TARole: "imported_groups",
    maxRecentlyViewedSize: 3,
    pageTitle: "PAWS",
    emailIconName: "Email",
    unreadExpiryTime: 15,
    enableGA: true,
    gaTrackingId: "G-7P8QY8C9QK",
    notificationTimeout: 5000,
    checkForUpdatesInterval: ( 5 * 60 * 1000 ),
    logLevel: "ERROR",
    RTLifetimeInMinutes: 90,
    sessionTimeoutShowNotificationInSeconds: 90,
    showIneligibleChannels: true,
    showChannelEligibility: false,
    showChannelListRoleFilter: true,
    feature_UsaskSearch: true,
    feature_SearchFeedback: true,
    feature_DigitalAssistant: false,
    feature_O365: false,
    feature_studentEnrollment: true,
    feature_CountdownEvents: true,
    feature_UChat: true,
    feedbackPostURL: "https://phpapps.usask.ca/site-feedback/feedback_post.php",
    searchPageSize: 15,
    CPKBUrl: "https://jira.usask.ca/servicedesk/customer/portal/1",
    LBKBUrl: "https://teamdynamix.usask.ca/TDClient/33/Portal/Login.aspx?ReturnUrl=%2fTDClient%2f33%2fPortal%2fKB%2f?CategoryID=3", //https://jira.usask.ca/servicedesk/customer/portal/13",
    ITSUrl: "https://teamdynamix.usask.ca/TDClient/33/Portal/Login.aspx?ReturnUrl=%2fTDClient%2f33%2fPortal%2fKB%2f?CategoryID=1", // https://teamdynamix.usask.ca/TDClient/33/Portal/KB/?CategoryID=1",
    STUKBUrl: "https://teamdynamix.usask.ca/TDClient/33/Portal/Login.aspx?ReturnUrl=%2fTDClient%2f33%2fPortal%2fKB%2f?CategoryID=2", ///https://jira.usask.ca/servicedesk/customer/portal/7",
    aiPilotRole: "digital_assistant_pilot",
    employeeVisibleRoles: "employee,advisor,advisor_admin",
    MyCollegeCategoryID: 8,
    usaskAnnouncementLabelsIds: "1,4267",
    hiddenCategories: "Icon,HIDDEN",
    gonamesWithDisabledBreadcrumbs:"articles",
    itSupportSubmitLink: "https://teamdynamix.usask.ca/TDClient/33/Portal/Requests/ServiceDet?ID=95",
    TDxLoginURL: "https://teamdynamix.usask.ca/TDClient/33/Portal/Login.aspx?returnURL=",
    MSOAuth_GraphAPI: "https://graph.microsoft.com/v1.0",
    MSOAuth_appID: '8b0e3c29-8301-4174-b8ee-4cbc16f4d7b2',
    MSOAuth_tenant: 'daa6c3c0-e283-47e5-85e2-bddf85a39c03',
    MSOAuth_redirectUri: 'https://paws.usask.ca/msal',
    MSOAuth_scopes: ['User.Read', 'Calendars.ReadBasic'],
    MSOAuth_loginHint: "usask.ca",
    student_agent_roles: "digital_assistant_student_pilot",
    it_agent_roles: "employee,student"
};
